// extracted by mini-css-extract-plugin
export default {"info-icon":"MediaGallery_info-icon__SiITo","top-upload-btn":"MediaGallery_top-upload-btn__jpb+0","content-divider":"MediaGallery_content-divider__6UM6B"};